import { matchPath } from 'react-router-dom';

/**
 * Extracts subscriptionId from the pathname using route patterns.
 * Falls back to check both /:subscriptionId/:packId/* and /:subscriptionId/:packId.
 *
 * @param {string} pathname
 * @returns {string|undefined} subscriptionId
 */
export function getSubscriptionIdFromPath(pathname) {
  if (!pathname) {
    return undefined;
  }

  // Two patterns are required to match routes with nested subpaths (e.g. /:subscriptionId/:packId/library)
  // as well as the exact base path (e.g. /:subscriptionId/:packId)
  const match =
    matchPath('/:subscriptionId/:packId/*', pathname) ||
    matchPath('/:subscriptionId/:packId', pathname);

  return match?.params?.subscriptionId;
}
